import { Component, inject } from '@angular/core';

import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';
import { InstructionBuilderService } from '../services/instruction-builder.service';
import { IInstructions } from '../../../interfaces/i-instructions';
import { AgentService } from '../../../../agent/services/agent.service';

@Component({
  selector: 'app-instruction-summary',
  imports: [
    MatCardModule,
    MatListModule,
    MatDividerModule,
    MatChipsModule,
    KENDO_LISTVIEW
],
  templateUrl: './instruction-summary.component.html',
  styleUrl: './instruction-summary.component.scss'
})
export class InstructionSummaryComponent {
  showInstructionSecuritySummary: boolean = false;

  agentService = inject(AgentService);
  #instructionBuilderService = inject(InstructionBuilderService);

  instruction: IInstructions;
  instructionAgentName: string = '';

  constructor() {
    if (this.#instructionBuilderService.instruction().details.agent) {
      this.instructionAgentName = this.agentService.getAgentNameFromId(this.#instructionBuilderService.instruction().details.agent!);
    }
    this.instruction = this.#instructionBuilderService.instruction();
  }
}
